import React from 'react'

function ErrorPageNotFound() {
  return (
    <div>
      <h1 className='display-1 text-danger'>
        Ugh! <br />
        404 - Page not found
      </h1>
    </div>
  )
}

export default ErrorPageNotFound